import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=593ecb22"
import script from "./SelectTable.vue?vue&type=script&lang=ts"
export * from "./SelectTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports